import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { Container, Box, Grid, Paper, Typography, Alert, Skeleton } from '@mui/material';
import { fetchDashboardData } from '../redux/slices/professionalDashboardSlice';

function StatTile({ title, value }) {
  return (
    <Paper elevation={1} sx={{ p: 2, borderRadius: 2 }}>
      <Typography variant="subtitle2" color="text.secondary">
        {title}
      </Typography>
      <Typography variant="h5" sx={{ mt: 1 }}>
        {value}
      </Typography>
    </Paper>
  );
}

const Analytics = () => {
  const dispatch = useDispatch();
  const { stats, loading, error } = useSelector((state) => state.professionalDashboard);

  useEffect(() => {
    // Charger les données du tableau de bord (statistiques utilisateur, candidatures, missions)
    dispatch(fetchDashboardData());
  }, [dispatch]);

  return (
    <>
      <Helmet>
        <title>Mes statistiques - Mission Sport</title>
        <meta name="description" content="Visualisez vos statistiques personnelles sur Mission Sport." />
      </Helmet>

      <Container maxWidth="lg" sx={{ py: 3 }}>
        <Box sx={{ mb: 3 }}>
          <Typography variant="h4" component="h1">
            Mes statistiques
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Aperçu de vos activités et performances.
          </Typography>
        </Box>

        {/* Message d'erreur éventuel */}
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={3}>
            {loading ? (
              <Paper elevation={1} sx={{ p: 2, borderRadius: 2 }}>
                <Skeleton variant="text" width={140} />
                <Skeleton variant="text" width={80} />
              </Paper>
            ) : (
              <StatTile title="Candidatures envoyées" value={stats?.missionsApplied || 0} />
            )}
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            {loading ? (
              <Paper elevation={1} sx={{ p: 2, borderRadius: 2 }}>
                <Skeleton variant="text" width={140} />
                <Skeleton variant="text" width={80} />
              </Paper>
            ) : (
              <StatTile title="Missions en cours" value={stats?.missionsInProgress || 0} />
            )}
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            {loading ? (
              <Paper elevation={1} sx={{ p: 2, borderRadius: 2 }}>
                <Skeleton variant="text" width={140} />
                <Skeleton variant="text" width={80} />
              </Paper>
            ) : (
              <StatTile title="Missions terminées" value={stats?.missionsCompleted || 0} />
            )}
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            {loading ? (
              <Paper elevation={1} sx={{ p: 2, borderRadius: 2 }}>
                <Skeleton variant="text" width={180} />
                <Skeleton variant="text" width={80} />
              </Paper>
            ) : (
              <StatTile title="Revenus estimés (€)" value={stats?.estimatedRevenue || 0} />
            )}
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default Analytics;